import React, { useState } from 'react';
import { apiHolder as api, apis } from 'api';
import { Radio, Space, DatePicker, Button } from 'antd';
import message from '@web-common/components/UI/Message/SiriusMessage';
import cnlocale from 'antd/es/date-picker/locale/zh_CN';
import moment from 'moment';
import { SiriusHtmlModal } from '@web-common/components/UI/Modal/SiriusModal';
import styles from './sortTimeRangeModel.module.scss';
import { getIn18Text } from 'api';
const trackApi = api.api.requireLogicalApi(apis.dataTrackerApiImp);
const RangePickerPH = [getIn18Text('KAISHIRIQI'), getIn18Text('JIESHURIQI')];
const SortTimeRangeModel = (props) => {
    const { destroy, onComplete } = props;
    const [rangeType, setRangeType] = useState(1);
    const [diyMoment, setDiyMoment] = useState([]);
    const onClose = () => {
        destroy && destroy();
    };
    const onChangeRangeType = (e) => {
        const curVal = e.target.value;
        setRangeType(curVal);
        if (curVal != 3) {
            setDiyMoment([]);
        }
    };
    const onCalendarChange = (dates) => {
        setDiyMoment(dates);
    };
    const disabledDateFun = (current) => {
        if (!diyMoment || diyMoment.length < 1) {
            return false;
        }
        const tooLate = diyMoment[0] && current && current.diff(diyMoment[0], 'days') >= 30;
        const tooEarly = diyMoment[1] && diyMoment[1].diff(current, 'days') >= 30;
        return !!tooEarly || !!tooLate;
    };
    const onCancel = () => {
        onComplete && onComplete(false);
        destroy && destroy();
    };
    const onConfirm = () => {
        var _a, _b;
        let optionStr = '';
        let dayPeriod = [];
        if (rangeType === 1) {
            optionStr = '最近15天';
            dayPeriod = [moment().subtract(14, 'day').format('YYYY-MM-DD'), moment().format('YYYY-MM-DD')];
        }
        if (rangeType === 2) {
            optionStr = '最近30天';
            dayPeriod = [moment().subtract(29, 'day').format('YYYY-MM-DD'), moment().format('YYYY-MM-DD')];
        }
        if (rangeType === 3) {
            optionStr = '自定义30天内时间范围';
            if (diyMoment.length < 2 || !diyMoment[0] || !diyMoment[1]) {
                message.error({ content: getIn18Text('QINGXUANZELIANXU') });
                return;
            }
            dayPeriod = [(_a = diyMoment[0]) === null || _a === void 0 ? void 0 : _a.format('YYYY-MM-DD'), (_b = diyMoment[1]) === null || _b === void 0 ? void 0 : _b.format('YYYY-MM-DD')];
        }
        optionStr && trackApi.track('pcMail_click_submit_sortTimePage', { option: optionStr });
        onComplete && onComplete(true, dayPeriod);
        destroy && destroy();
    };
    return (React.createElement(SiriusHtmlModal, { width: 360, visible: true, destroyOnClose: true, footer: null, closable: false },
        React.createElement("div", { className: styles.wrap },
            React.createElement("div", { className: styles.title },
                React.createElement("div", { className: styles.name }, getIn18Text('XUANZEPAIXUSHIJIANFANWEI')),
                React.createElement("div", { className: styles.close, onClick: onClose })),
            React.createElement("div", { className: `ant-allow-dark ${styles.content}` },
                React.createElement(Radio.Group, { onChange: onChangeRangeType, value: rangeType },
                    React.createElement(Space, { direction: "vertical" },
                        React.createElement(Radio, { value: 1 }, getIn18Text('ZUIJIN15')),
                        React.createElement(Radio, { value: 2 }, getIn18Text('ZUIJIN30')),
                        React.createElement(Radio, { value: 3 },
                            getIn18Text('ZIDINGYI30'),
                            rangeType === 3 && (React.createElement(React.Fragment, null,
                                React.createElement("br", null),
                                React.createElement(DatePicker.RangePicker, { allowEmpty: [true, true], placeholder: RangePickerPH, format: "YYYY-MM-DD", locale: cnlocale, disabledDate: disabledDateFun, onCalendarChange: onCalendarChange, suffixIcon: "" }))))))),
            React.createElement("div", { className: styles.footerArea },
                React.createElement(Button, { type: "primary", className: styles.confirmBut, onMouseDown: onConfirm }, getIn18Text('QUEDING')),
                React.createElement(Button, { type: "default", className: styles.cancelBut, onMouseDown: onCancel }, getIn18Text('QUXIAO'))))));
};
export default SortTimeRangeModel;
